import { useMemo } from 'react';
import classes from './QualifyingCriteria.module.css';
import QualifyingCriteriaConfigV2 from 'features/training/assessment/ModuleBased/QualifyingCriteriaConfigV2';
import QualifyingCriteriaRealplay from 'features/realplays/Components/QualifyingCriteria/QualifyingCriteriaRealplay';
import { useListPassingCriteriaQuery } from './QualifiyingCriteria.queries';

const QualifyingCriteriaSection = () => {
  const { data, isLoading } = useListPassingCriteriaQuery();

  const moduleQuizzes = useMemo(() => {
    if (!data || data.length === 0) return {};
    const item = data?.criteria.find((c) => c.key === 'module_assessment_passing_criteria');
    return item
      ? {
          module_assessments: {
            rating_to_qualify: item?.min_value,
            uuid: item?.uuid,
          },
        }
      : {};
  }, [data]);

  const interactiveRoleplay = useMemo(() => {
    if (!data || data.length === 0) return {};
    const item = data?.criteria.find((c) => c.key === 'roleplay_passing_criteria');
    return item
      ? {
          roleplay: {
            rating_to_qualify: item?.min_value,
            uuid: item?.uuid,
          },
        }
      : {};
  }, [data]);

  return (
    <div className={classes.container}>
      <QualifyingCriteriaConfigV2 data={moduleQuizzes} isLoading={isLoading} />
      <QualifyingCriteriaRealplay data={interactiveRoleplay} isLoading={isLoading} />
    </div>
  );
};

export default QualifyingCriteriaSection;
